exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3YS20J8OpBDFhBDeCjdvrX{width:192px;overflow:hidden}html[dir] ._3YS20J8OpBDFhBDeCjdvrX{padding:8px;background:\"[theme:white, default:#ffffff]\"}._3YS20J8OpBDFhBDeCjdvrX ul{width:192px;overflow:hidden}._1-8R5_HZul3CLBXRT0KPiI{display:inline-block;width:32px;height:32px}html[dir] ._1-8R5_HZul3CLBXRT0KPiI{background:\"[theme:white, default:#ffffff]\"}._1-8R5_HZul3CLBXRT0KPiI button{min-width:0}html[dir] ._1-8R5_HZul3CLBXRT0KPiI button{padding:0;background:transparent}._1at9R5Os0T5ZLgYzbCLnqG{width:20px;height:20px}html[dir] ._1at9R5Os0T5ZLgYzbCLnqG{margin:4px;border:2px solid transparent}html[dir] ._1at9R5Os0T5ZLgYzbCLnqG:hover,html[dir] body.addFocusOutline ._1at9R5Os0T5ZLgYzbCLnqG:focus{border-color:#e81123}", ""]);

// exports
exports.locals = {
	"colorPickerContainer": "_3YS20J8OpBDFhBDeCjdvrX",
	"colorMenuItem": "_1-8R5_HZul3CLBXRT0KPiI",
	"colorSquare": "_1at9R5Os0T5ZLgYzbCLnqG"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":{"orderedValues":false}}!./node_modules/postcss-loader/lib?{"plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./obj/controls/owa-color-picker/lib/components/ColorPicker.scss
// module id = 3315
// module chunks = 2 59